/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ClinicRequestStatus =
  (typeof ClinicRequestStatus)[keyof typeof ClinicRequestStatus];

export const ClinicRequestStatus = {
  created: "created",
  pending: "pending",
  in_progress: "in_progress",
  updated: "updated",
  complete: "complete",
  cancelled: "cancelled",
  voided: "voided",
} as const;
